import { render, staticRenderFns } from "./UserManagementV2.vue?vue&type=template&id=476326a9&scoped=true&"
import script from "./UserManagementV2.vue?vue&type=script&lang=ts&"
export * from "./UserManagementV2.vue?vue&type=script&lang=ts&"
import style0 from "./UserManagementV2.vue?vue&type=style&index=0&id=476326a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476326a9",
  null
  
)

export default component.exports